import { render, staticRenderFns } from "./LeaveEmployeeInfo.vue?vue&type=template&id=0c686534&scoped=true"
import script from "./LeaveEmployeeInfo.vue?vue&type=script&lang=js"
export * from "./LeaveEmployeeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c686534",
  null
  
)

export default component.exports